import styles from "../../../../assets/scss/common/modal/loginModal.module.scss";
import sendIcon from "../../../../assets/images/modal/login/send_icon.svg";
import { useModal, useUserAgent } from "../../../../hooks/hooks";
import React, { useCallback, useEffect, useState } from "react";
import { LoginStep } from "../LoginModal";
import { usePhoneNumberByEmailGetter } from "./hooks/usePhoneNumberByEmailGetter";
import { useCodeSender } from "./hooks/useCodeSender";
import { RequestCodeType } from "../../../../types/auth";
import {AuthWay} from "../../../../types/user";
import {Trans, useTranslation} from "react-i18next";

interface Props {
  changeLoginStep: (_: LoginStep) => void;
  email: string;
  setPhoneNumber: (_: string) => void;
  phoneNumber: string;
  setTitle: (_: string) => void;
}

export function AuthWayChoiceStep({
    changeLoginStep, email, setPhoneNumber, phoneNumber, setTitle
}: Props) {
  const { t } = useTranslation("signupModal");
  const { isDesktop, isTablet } = useUserAgent();
  const { getPhoneNumberByEmailGetter } = usePhoneNumberByEmailGetter();
  const { openAlertModal } = useModal();
  const [authWay, setAuthWay] = useState(AuthWay.NONE);
  const [errorMessage, setErrorMessage] = useState("");
  const { sendCode } = useCodeSender();

  useEffect(() =>{
    setTitle(t("login.title"))
  })

  const onClickCancelButton = useCallback(() => {
    setTitle(t("signupAndLogin.title"))
    changeLoginStep(LoginStep.EMAIL);
    // eslint-disable-next-line
  }, [changeLoginStep]);

  const onClickSendCodeButton = useCallback(() => {
    if (authWay === AuthWay.NONE) {
      setErrorMessage(t("warning.authenticate.noneSelectAuthWay"));
      return;
    }

    sendCode(email, authWay === AuthWay.EMAIL ? RequestCodeType.EMAIL : RequestCodeType.PHONE_NUMBER)
      .then(() => changeLoginStep(authWay === AuthWay.EMAIL ? LoginStep.EMAIL_CODE : LoginStep.PHONE_NUMBER_CODE))
      .catch();
  }, [authWay, email, changeLoginStep, sendCode, t]);

  const onClickAuthWayButton = useCallback((toAuthWay: AuthWay) => {
    setAuthWay(toAuthWay);
    setErrorMessage("");
  }, []);

  useEffect(() => {
    setPhoneNumber("");
    setAuthWay(AuthWay.NONE);

    if (email) {
      getPhoneNumberByEmailGetter(email)
        .then((phoneNumber) => setPhoneNumber(phoneNumber))
        .catch((e) => {
          console.error(e);
          openAlertModal(null);
          changeLoginStep(LoginStep.EMAIL);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  return (
    <div className={styles.authWayWrapper}>
      <div className={styles.desc}>
        <Trans t={t} i18nKey={isDesktop || isTablet ?"login.desc1" : "login.desc1Mo"}
               components={{accent: <span className={styles.accent} />,br : <br />}}
        />
      </div>
      <div className={styles.waysWrapper}>
        <button
          className={`${styles.aWay} ${authWay === AuthWay.PHONE ? styles.active : ""}`}
          onClick={() => onClickAuthWayButton(AuthWay.PHONE)}
        >
          <div className={styles.checkbox}></div>
          <span className={styles.label}>
            <span>{t('login.cellphone')}&nbsp;</span>
            <span className={styles.light}>({phoneNumber})</span>
          </span>
        </button>
        <button
          className={`${styles.aWay} ${authWay === AuthWay.EMAIL ? styles.active : ""}`}
          onClick={() => onClickAuthWayButton(AuthWay.EMAIL)}
        >
          <div className={styles.checkbox}></div>
          <span className={styles.label}>
            <span>{t('login.email')}&nbsp;</span>
            <span className={styles.light}>({email})</span>
          </span>
        </button>
        {errorMessage ? <span className={styles.errorMessage}>{errorMessage}</span> : <></>}
      </div>

      <div className={styles.buttonsWrapper}>
        <button className={styles.outlineButton} onClick={onClickCancelButton}>
          {t("btn.cancel")}
        </button>
        <button className={styles.primaryButton} onClick={onClickSendCodeButton}>
          {t("btn.sendCode")}
          <img className={styles.icon} src={sendIcon} alt={"보내기"} />
        </button>
      </div>
    </div>
  );
}
